import {Link} from "react-router-dom";
import SVGIcon from "./SVGIcon";
import React from "react";
import BookIcon from './svg/book.svg';
import CardImage from './svg/card-image.svg';

export default function SearchResult(props) {
    return (
        <tr>
            <td>
                <Link to={'specimen/'+props.specimen.id}>
                    {props.specimen.catalog_number}
                </Link>
            </td>
            <td>
                {props.specimen.name}
            </td>
            <td>
                {props.specimen.common_name}
            </td>
            <td>
                {props.specimen.locality_no}
            </td>
            <td>
                {props.specimen.case_number}
            </td>
            <td>
                {props.specimen.images.length > 0 ?
                    (<SVGIcon title="Has Images" src={CardImage} />) : ''}
                {props.specimen.type_id ?
                    (<SVGIcon title={props.specimen.type.name} src={BookIcon} />) : ''}
            </td>
        </tr>
    )
}
